(() => {
  const page = document.querySelector('.jootti-field-guide[data-fg-record]');
  if (!page) return;
  const type = page.dataset.fgRecord;
  const handle = page.dataset.fgHandle;
  const events = {
    jootti_field_guide_entry: ['field_guide_entry_view', 'entry_handle'],
    jootti_field_guide_family: ['field_guide_family_view', 'family_handle'],
    jootti_field_guide_pathway: ['field_guide_pathway_select', 'pathway_handle'],
    jootti_field_guide_comparison: ['field_guide_compare_view', 'comparison_handle'],
  };
  const publish = (name, properties) => {
    try {
      if (typeof window.Shopify?.analytics?.publish !== 'function') return false;
      window.Shopify.analytics.publish(name, {guide: 'megabass', ...properties});
      return true;
    } catch (_) {
      return false;
    }
  };
  const event = events[type];
  if (event && handle) publish(event[0], {[event[1]]: handle});
  page.addEventListener('click', click => {
    const link = click.target.closest('a[data-fg-product-id]');
    if (!link || !page.contains(link)) return;
    publish('field_guide_product_click', {entry_handle: handle, product_id: link.dataset.fgProductId});
  });
})();
